import React from "react";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Tv from "../../../assets/icons/Icontv2.png";
import Anhaguera from "../../../assets/icons/anhanguera.png";
import SerraDourada from "../../../assets/icons/serradourada.png";
import JpNews from "../../../assets/icons/jpnews.png";
import HeH from "../../../assets/icons/h&h.png";
import Espn from "../../../assets/icons/espn.png";
import PrimeBox from "../../../assets/icons/primebox.png";
import history from "../../../assets/icons/history.png";
import Disney from "../../../assets/icons/disney.png";
import AnimalPlanet from "../../../assets/icons/animalplanet.png";

import Fishtv from "../../../assets/icons/fishtv.png";
import Discovery from "../../../assets/icons/discovery.png";
import Turbo from "../../../assets/icons/turbo.png";
import * as ImIcons from "react-icons/im";
import * as FcIcons from "react-icons/fc";

import './styles.css';

const Planos = () => {
  return (

    <div className="container plan">
      <div className="row  py-4">
        <h1>TV na Fibra</h1>
        <h4>Instruções para auxiliar na escolha do plano de TV</h4>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> GIGA LIVRE HD   </h2>
              </div>
              <Card.Header></Card.Header>

              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <ImIcons.ImDisplay />
                    <span>43  Canais de TV</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcMoneyTransfer />
                    <span>13 Canais HD</span>
                    <p>o prazo de instalação e a grade de canais podem variar conforme a cidade </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcStart />
                    <span>Aplicativo Gigabyte Play incluso</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <ImIcons.ImDisplay />
                    <span>Canais do plano</span>
                    <p>+ conheça os canais </p>
                    <div className="img-icon-content">
                      <img src={Anhaguera} alt="icon" />
                      <img src={SerraDourada} alt="icon" />
                      <img src={JpNews} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <h6>
                      de R$ 100,00/MÊS
                    </h6>
                    <span>
                      por R$ 80,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Combo 30 MEGA Internet + GIGA LIVRE HD
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary">Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> GIGA START HD </h2>
              </div>
              <Card.Header></Card.Header>

              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <ImIcons.ImDisplay />
                    <span>65  Canais de TV</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcMoneyTransfer />
                    <span>22 Canais HD</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcStart />
                    <span>Aplicativo Gigabyte Play incluso</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <ImIcons.ImDisplay />
                    <span>Canais do plano</span>
                    <p>+ conheça os canais </p>
                    <div className="img-icon-content">
                      <img src={HeH} alt="icon" />
                      <img src={PrimeBox} alt="icon" />
                      <img src={Espn} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <h6>
                      de R$ 140,00/MÊS
                    </h6>
                    <span>
                      por R$ 120,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Combo 30 MEGA Internet + GIGA START HD
                    </p>
                  </div>

                </Card.Text>
                <Button variant="primary">Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> GIGA PLUS HD  </h2>
              </div>
              <Card.Header></Card.Header>

              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <ImIcons.ImDisplay /><span>87  Canais de TV</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcMoneyTransfer /><span>28 Canais HD</span>
                    <p>o prazo de instalação pode variar </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcStart />
                    <span>Aplicativo Gigabyte Play incluso</span>
                    <p>assista seus canais favoritos em qualquer lugar </p>
                  </div>
                  <div className="img-icon">
                    <ImIcons.ImDisplay /><span>Canais do plano</span>
                    <p>conheça alguns canais deste plano</p>
                    <div className="img-icon-content">
                      <img src={AnimalPlanet} alt="icon" />
                      <img src={history} alt="icon" />
                      <img src={Disney} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <h6>
                      de R$ 160,00/MÊS
                    </h6>
                    <span>
                      por R$ 140,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Combo 30 MEGA Internet + GIGA PLUS HD
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary">Saiba mais...</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="col-sm-12 col-md-3">
          <div className="content-card">
            <Card>
              <div className="img-icon-tv">
                <img src={Tv} alt="foto" />
                <h2> GIGA FULL HD </h2>
              </div>
              <Card.Header></Card.Header>
              <Card.Body>

                <Card.Text>
                  <div className="img-icon">
                    <ImIcons.ImDisplay /><span>98  Canais de TV</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcMoneyTransfer /><span>32 Canais HD</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <FcIcons.FcStart /><span>Aplicativo Gigabyte Play incluso</span>
                    <p>+ conheça os canais </p>
                  </div>
                  <div className="img-icon">
                    <ImIcons.ImDisplay /><span>Canais do plano</span>
                    <p>+ conheça os canais </p>
                    <div className="img-icon-content">
                      <img src={Discovery} alt="icon" />
                      <img src={Fishtv} alt="icon" />
                      <img src={Turbo} alt="icon" />
                    </div>
                  </div>
                  <div className="price">
                    <h6>
                      de R$ 180,00/MÊS
                    </h6>
                    <span>
                      por R$ 160,00/MÊS
                    </span>
                    <hr />
                    <p>
                      Combo 30 MEGA Internet + GIGA PLUS HD
                    </p>
                  </div>
                </Card.Text>
                <Button variant="primary">Saiba mais...</Button>
              </Card.Body>
            </Card>
            <div className="end"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Planos;
